import React, { useEffect } from "react";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="term-and-condition" style={{ marginTop: "60px", marginBottom: "100px" }}>
        <div className="container">
          <div className="sm-box">
            <h4>Terms and Conditions</h4>
            <p>
              <i>Effective Date: [06 NOV 2023]</i>
            </p>

            <div className="content">
              <div className="para-section">
                <p>
                  DataFluent Analytics Limited is an AI-based IT-enabled solution-providing
                  company registered at the Dhaka Joint Stock Company, Bangladesh. To use this
                  website, you must agree to the following terms and conditions. Therefore, we
                  ask visitors of this website to go through this document to understand the
                  terms and conditions.
                </p>

                <p>
                  <strong>1. Acceptance of Terms: </strong>
                  By accessing and using this website, you agree to be bound by these Terms and
                  Conditions of Use. If you do not agree with any part of these terms, please
                  refrain from using this website.
                </p>

                <div>
                  <strong>2. User Responsibilities: </strong>
                  <ul>
                    <li>You must be at least 18 years old to use this website.</li>
                    <li>
                      You are responsible for maintaining the confidentiality of your account
                      information.
                    </li>
                    <li>
                      You agree to use the website in compliance with applicable laws and
                      regulations.
                    </li>
                  </ul>

                  <strong>3. Intellectual Property: </strong> 
                  <ul>
                    <li>
                      All content on this website, including text, graphics, logos, images, and
                      software, is the property of DataFluent Analytics and is protected by
                      intellectual property laws.
                    </li>
                    <li>
                      You may not reproduce, distribute, or exploit any content from this
                      website without explicit permission.
                    </li>
                  </ul>

                  <p>
                    <strong>4. Privacy Policy: </strong> 
                    Your use of this website is also governed by our Privacy Policy, which can
                    be found [link to privacy policy]. By using this website, you agree to the
                    terms outlined in the Privacy Policy.
                  </p>

                  <p>
                    <strong>5. Disclaimer of Warranties</strong> 
                    This website is provided on an "as-is" and "as-available" basis.
                    DataFluent Analytics makes no warranties, expressed or implied, regarding
                    the accuracy, reliability, or completeness of the content.
                  </p>

                  <p>
                    <strong>6. Limitation of Liability: </strong> 
                    DataFluent Analytics shall not be liable for any direct, indirect,
                    incidental, consequential, or special damages arising out of or in any
                    way connected with your use of this website. DataFluent Analytics disclaims
                    any responsibility for any harm resulting from your use of this website.
                  </p>
                  <p>
                    <strong>7. Modifications: </strong> 
                    DataFluent Analytics reserves the right to modify or amend these Terms
                    and Conditions of Use at any time. Your continued use of the website
                    constitutes acceptance of any changes.
                  </p>
                  <p>
                    <strong>8. Governing Law: </strong> 
                    These terms and conditions are governed by and construed by the laws of
                    Bangladesh. Any disputes arising out of or in connection with these terms
                    shall be resolved by the courts of Bangladesh.
                  </p>
                  <p>
                    <strong>9. Contact Information: </strong> 
                    If you have any questions or concerns about these terms, please contact
                    us at{" "}
                    <a href="mailto:dfaadmin@datafluent.xyz">dfaadmin@datafluent.xyz</a> or call
                    us +880-1994388587. We are happy to hear from you. Thank you!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;